import { TextField } from '@material-ui/core'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Workspace } from '../../../providers/workspace'
import { SuccessButton } from '../../Buttons'
import { CardProfile } from './CardProfile'

type Props = {
  editingWorkspace: Workspace
  onSave: (workspace: Workspace) => void
  loading: boolean
}

function getBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      resolve(reader.result as string)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}
export const AccountMainFormComponent = ({
  editingWorkspace,
  onSave,
  loading
}: Props): JSX.Element => {
  const { control, handleSubmit, watch, errors } = useForm<Workspace>({
    defaultValues: editingWorkspace
  })
  const [thumb, setThumb] = React.useState(editingWorkspace.thumb as string)
  const [thumbFile, setThumbFile] = React.useState<File | null>()

  const onSubmit = (data: Workspace) => {
    onSave({ ...data, thumb: thumbFile })
  }

  const values = watch()

  const handleDeleteImage = () => {
    setThumb('')
    setThumbFile(null)
  }

  const handleChangeImage = async (file: File) => {
    setThumbFile(file)
    const base64 = await getBase64(file)
    setThumb(base64)
  }

  return (
    <>
      <CardProfile
        editingWorkspace={{ ...editingWorkspace, ...values }}
        thumb={thumb as string}
        onDeleteImage={handleDeleteImage}
        onSelectImage={handleChangeImage}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Controller
            name="name"
            control={control}
            defaultValue=""
            rules={{ required: { value: true, message: 'Campo obrigatório' } }}
            render={({ onChange, value }) => (
              <TextField
                onChange={onChange}
                value={value}
                label="Nome"
                error={!!errors.name}
                helperText={errors.name?.message || ''}
                fullWidth
              />
            )}
          />
        </div>
        <br />
        <div>
          <Controller
            name="crm"
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <TextField
                onChange={onChange}
                value={value}
                label="CRM"
                style={{ width: '15%', marginRight: '5%' }}
              />
            )}
          />
          <Controller
            name="company"
            rules={{ required: { value: true, message: 'Campo obrigatório' } }}
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <TextField
                onChange={onChange}
                value={value}
                error={!!errors.company}
                helperText={errors.company?.message || ''}
                label="Nome do Hospital / Clínica"
                style={{ width: '80%' }}
              />
            )}
          />
        </div>
        <br />
        <div>
          <Controller
            name="phone"
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <TextField
                onChange={onChange}
                value={value}
                label="Telefone"
                style={{ width: '47.5%', marginRight: '5%' }}
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            rules={{
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: 'Email inválido'
              }
            }}
            defaultValue=""
            render={({ onChange, value }) => (
              <TextField
                error={!!errors.email}
                helperText={errors.email?.message || ''}
                onChange={onChange}
                value={value}
                label="Email Comercial"
                style={{ width: '47.5%' }}
              />
            )}
          />
        </div>
        <br />
        <br />
        <SuccessButton
          fullWidth
          type="submit"
          style={{ padding: 10 }}
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar'}
        </SuccessButton>
      </form>
    </>
  )
}

export const AccountMainForm = React.memo(AccountMainFormComponent)
